module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av654-579f5d054179c6ca61d05b729ebc3028.jpg";